import React from "react";

const HIGH = "High";
const MEDIUM = "Medium";
const UPDATE = "Update";

const AlertCriticalityCard = ({ status, style = {} }) => {
  // base style
  const baseStyle = {
    borderRadius: "4px",
    padding: "0px 15px 22px 15px",
    borderWidth: "0.6px",
    borderStyle: "solid",
    fontSize: "12px",
    height: "15px",
    display: "inline-block",
    ...style,
  };

  // conditional styles
  const statusStyle =
    status === HIGH
      ? { color: "var(--alert-high-color)", borderColor: "var(--alert-high-border-color)" }
      : status === MEDIUM
      ? { color: "var(--alert-medium-color)", borderColor: "var(--alert-medium-border-color)" }
      : status === UPDATE
      ? { color: "var(--alert-update-color)", borderColor: "var(--alert-update-border-color)" }
      : {};

  return <div style={{ ...baseStyle, ...statusStyle }}>{status}</div>;
};

export default AlertCriticalityCard;
